'use strict';

// Class definition
var KTChartsWidget29 = (function () {
  var chart = {
    self: null,
    rendered: false,
  };

  // Private methods
  var initChart = function (chart) {
    var element = document.getElementById('kt_charts_widget_29');

    if (!element) {
      return;
    }

    var height = parseInt(KTUtil.css(element, 'height'));
    var labelColor = KTUtil.getCssVariableValue('--bs-gray-500');
    var borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color');
    var baseColor = KTUtil.getCssVariableValue('--bs-warning');

    var options = {
      series: [
        {
          name: 'Position',
          data: [4, 7.5, 7.5, 6, 6, 4, 4, 6, 6, 8, 8, 6, 6, 7, 7],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'area',
        height: height,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0,
          stops: [0, 80, 100],
        },
      },
      stroke: {
        curve: 'smooth',
        show: true,
        width: 3,
        colors: [baseColor],
      },
      xaxis: {
        categories: [
          'Apr 02',
          'Apr 03',
          'Apr 04',
          'Apr 05',
          'Apr 06',
          'Apr 09',
          'Apr 10',
          'Apr 12',
          'Apr 14',
          'Apr 17',
          'Apr 18',
          'Apr 18',
          'Apr 20',
          'Apr 22',
          'Apr 24',
        ],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        offsetX: 20,
        tickAmount: 4,
        labels: {
          rotate: 0,
          rotateAlways: false,
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: baseColor,
            width: 1,
            dashArray: 3,
          },
        },
        tooltip: {
          enabled: true,
          formatter: undefined,
          offsetY: 0,
          style: {
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        tickAmount: 4,
        max: 10,
        min: 1,
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
          formatter: function (val) {
            return val;
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      colors: [baseColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      markers: {
        strokeColor: baseColor,
        strokeWidth: 3,
      },
    };

    chart.self = new ApexCharts(element, options);

    // Set timeout to properly get the parent elements width
    setTimeout(function () {
      chart.self.render();
      chart.rendered = true;
    }, 200);
  };

  // Public methods
  return {
    init: function () {
      initChart(chart);

      // Update chart on theme mode change
      KTThemeMode.on('kt.thememode.change', function () {
        if (chart.rendered) {
          chart.self.destroy();
        }

        initChart(chart);
      });
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTChartsWidget29;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget29.init();
});
